// extracted by mini-css-extract-plugin
export default {"container":"galleryComponent_container__SIaCM","wrapper":"galleryComponent_wrapper__iPy-u","imgDiv":"galleryComponent_imgDiv__7bq+O","buttonDiv":"galleryComponent_buttonDiv__d1rdQ"};